<div class="container">
    <div class="overlay" (click)="onCloseClick()"></div>
    <div class="wrapper" [style]="!this.isMobile ? 'background-image: url(assets/img/moviesphere-plus/promo/moviesphere-plus-offer-overlay.jpg)' : 'background-image: url(assets/img/moviesphere-plus/promo/moviesphere-plus-offer-overlay-mobile.jpg)' ">
        
        <button class="close-btn" (click)="onCloseClick()" aria-label="Close popup">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L19 19M19 1L1 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </button>
        <div class="content">
            <h2 class="heading">Promotional Offer:</h2>
            <p class="body-text">Watch more of what you love with a subscription to MovieSphere+. Choose from MovieSphere+ and many more subscriptions, all on Prime Video. <br>
            <b>From $0.99/month for 2 months and then $4.99/month thereafter. <br> Offer ends June 26.</b>
            </p>
        </div>
    </div>
</div>
